import React, { useState } from 'react';

import { SingleActionLayout } from '@/components/shared/SingleActionLayout/SingleActionLayout';
import { AsaphSwitch } from '@/components/shared/Switch';
import { ListItem, ListItemText } from '@material-ui/core';

import { IPropsSongModalDisplay } from '../SongModalPanel';

export const NewSong: React.FC<IPropsSongModalDisplay> = ({
	openedSong,
	popDisplayState,
	updateTeamSong,
}) => {
	const { new: newSong } = openedSong;
	const [touched, setTouched] = useState(false);
	const [selectedValue, setSelectedValue] = useState<boolean>(
		newSong ?? false,
	);

	return (
		<SingleActionLayout
			noPadding
			actionDisabled={!touched}
			actionLabel="Save"
			onActionClick={() => {
				updateTeamSong({
					new: selectedValue,
				});
				popDisplayState();
			}}
		>
			<ListItem button key={0}>
				<ListItemText
					primary="Mark as new song"
					secondary="Adds a marker next to the song name in Songs which the whole team can see"
				/>
				<AsaphSwitch
					checked={selectedValue}
					onChange={(e) => {
						setSelectedValue(e.currentTarget.checked);
						setTouched(true);
					}}
				/>
			</ListItem>
		</SingleActionLayout>
	);
};
